export default class ProfileViewModel {
    public userId: string;
    public deviceId: string;
    public shipName: string;
    public shipHomeLocation: string;
    public geofenceRadius: number;
    public geofenceSirenEnabled: boolean;
    public geofenceLatitude: number;
    public geofenceLongitude: number;
    public isCaptain: boolean;
    public isApproved: boolean;
    public hasGalleryAccess: boolean;
    public hasUploadAccess: boolean;
    public isPaid: boolean;
    public mBsUsed: number;
    public dataLimit: number;
    public transactionsUsed: number;
    public transactionsLimit: number;
    public billingStart: string;
    public billingEnd: string;
}